import {useMutation} from "react-query";
import {CreateResidentDto} from "../types";
import {ResidentService} from "../../../services/ResidentServices";
import Alert from "react-s-alert";
import {useNavigate} from "react-router-dom";

export const useCreateResident = () => {
  const navigate = useNavigate();

  return useMutation(
    async (body: CreateResidentDto) => {
      const response = await ResidentService.createResident(body);
      return response;
    },
    {
      onSuccess: response => {
        Alert.success("Resident successfully created!");
        const residentId = response.data?.id;
        navigate(
          residentId ? `/admin/residents/${residentId}` : "/admin/residents",
        );
      },
      onError: (err: any) => {
        Alert.error(
          err?.data?.detail ? err?.data?.detail : "Something went wrong",
        );
      },
    },
  );
};
